import { makeFontToken } from "../css/token.font";
import { makeLengthToken } from "../css/token.length";

const figtree = makeFontToken("--figtree", {
  fontFaces: {
    light: ["figtree, helvetica, arial, sans-serif", 300],
    default: ["figtree, helvetica, arial, sans-serif", 400],
    medium: ["figtree, helvetica, arial, sans-serif", 600],
    bold: ["figtree, helvetica, arial, sans-serif", 700],
    ["extra-bold"]: ["figtree, helvetica, arial, sans-serif", 800],
  },
  default: "default",
});

const body = figtree.__extend("--body-font");

export const lineHeightScales = {
  figtree: 1,
  dyslexie: 1.41666667,
};

export const fontScales = {
  figtree: 1,
  dyslexie: 0.88889,
};

export const fonts = {
  lineHeight: makeLengthToken("--line--height", "1"),
  figtree,
  body,
};
